<template>
  <messages :data-src="messages" base-class="job-messages">
    <template slot="message" slot-scope="{ message }">
      <job-message
        :message="message"
        base-class="job-messages__message"
      ></job-message>
    </template>
  </messages>
</template>

<script>
import JobMessage from "./JobMessageListTab";

export default {
  components: {
    "job-message": JobMessage,
  },

  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      test: [],
    };
  },
  created() {
    this.test = this.messages
    // this.test = this.data;
  },
  watch: {
    messages: function (newQuestion, oldQuestion) {
      this.test = newQuestion;
    },
  },
};
</script>